import logger from 'loglevel';

/**
 * Supported methods
 *
 * logger.trace()
 * logger.debug()
 * logger.info()
 * logger.warn()
 * logger.error()
 */

export default logger;
